import { ConversationTagModel } from "../schema/conversation-tag.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class ConversationTagContainer extends MongoBaseContainer{
    conversation_tag: ConversationTagModel;
}